import { ReactNode, useReducer } from 'react';
import styled from 'styled-components';
import { Stack } from '@optimus-web/core';
import { DEFAULT_PORTAL_ID } from '@mews-commander/constants';
import { SearchNewEntityDialogBackendPage } from './SearchNewEntityDialogBackendPage';
import { useRefreshPageStore } from './refreshPageStore';
import { PreviousUrlProvider } from './previousUrl';

interface FakeModalManagerProps {
    children: ReactNode;
}

export const FakeModalManager = ({ children, ...props }: FakeModalManagerProps) => {
    /**
     * Using useReducer in this way allows to force rerender of the component.
     * The rerender is used to trigger a refresh of current page. We do it in this way because our current routing solution
     * does not support refresh of page.
     */
    const [key, forceUpdate] = useReducer((x) => x + 1, 0);
    const { shouldRefresh, reset } = useRefreshPageStore();
    if (shouldRefresh) {
        reset();
        forceUpdate();
    }

    return (
        <>
            <FakeModalManagerContainer {...props} key={key} id={DEFAULT_PORTAL_ID}>
                <PreviousUrlProvider>
                    <Stack fill vertical>
                        {children}
                    </Stack>
                </PreviousUrlProvider>
            </FakeModalManagerContainer>
            <SearchNewEntityDialogBackendPage />
        </>
    );
};

const FakeModalManagerContainer = styled.div`
    position: relative;
    flex: 1 1 auto;
    overflow: hidden;
    transform: translate3D(0, 0, 0);
`;
